<div class="sidebar-area bg-white" [class.active]="isSidebarToggled">
  <div class="header">
    <div class="logo">
      <a [routerLink]="dashboardRoute">
        <ng-container *ngIf="tenant$ | async as tenant">
          <img [src]="tenant.logoUrl" alt="Logo" />
        </ng-container>
      </a>
    </div>

    <button type="button" class="burger-menu" (click)="toggle()" aria-label="Toggle sidebar"
      [class.isSidebarToggled]="isSidebarToggled">
      <mat-icon>{{ isSidebarToggled ? "chevron_left" : "menu" }}</mat-icon>
    </button>
  </div>

  <ng-scrollbar visibility="hover">
    <div class="sidebar-inner">
      <div class="sidebar-menu">
        <mat-accordion>
          <ng-container *ngFor="let item of menuItems; trackBy: trackByIndex">
            <!-- CASE 1: Single Menu Item (No Sub-items) -->
            <a *ngIf="!item.subItems?.length" class="sidebar-menu-link" [class.locked-feature]="item.isLocked"
              (click)="handleNavigation(item)" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
              <i class="material-symbols-outlined test">{{ item.icon }}</i>
              <span class="title">{{ item.title | titlecase }}</span>
              <!-- Visual Lock Icon -->
              <mat-icon *ngIf="item.isLocked" class="lock-icon">lock</mat-icon>
            </a>

            <!-- CASE 2: Expandable Menu (With Sub-items) -->
            <mat-expansion-panel *ngIf="item.subItems?.length" [class.parent-locked]="item.isLocked">
              <mat-expansion-panel-header>
                <i class="material-symbols-outlined">{{ item.icon }}</i>
                <span class="title">{{ item.title }}</span>
                <span class="daxa-badge" *ngIf="item.subItems?.length">
                  {{ item.subItems?.length }}
                </span>
              </mat-expansion-panel-header>

              <ul class="sidebar-sub-menu">
                <li *ngFor="let sub of item.subItems" class="sidemenu-item">
                  <!-- Sub-item Link -->
                  <a *ngIf="!sub.subItems?.length" class="sidemenu-link" [class.locked-feature]="sub.isLocked"
                    (click)="handleNavigation(sub)" routerLinkActive="active">
                    <span>{{ sub.title | titlecase }}</span>
                    <mat-icon *ngIf="sub.isLocked" class="lock-icon-small">lock</mat-icon>
                  </a>

                  <!-- Nested Sub-items (Level 3) -->
                  <mat-expansion-panel *ngIf="sub.subItems?.length" class="nested-panel">
                    <mat-expansion-panel-header>
                      <span class="title">{{ sub.title | titlecase }}</span>
                    </mat-expansion-panel-header>
                    <ul class="sidebar-sub-menu nested">
                      <li *ngFor="let nestedSub of sub.subItems" class="sidemenu-item">
                        <a class="sidemenu-link" [class.locked-feature]="nestedSub.isLocked"
                          (click)="handleNavigation(nestedSub)" routerLinkActive="active">
                          {{ nestedSub.title | titlecase }}
                          <mat-icon *ngIf="nestedSub.isLocked" class="lock-icon-small">lock</mat-icon>
                        </a>
                      </li>
                    </ul>
                  </mat-expansion-panel>
                </li>
              </ul>
            </mat-expansion-panel>
          </ng-container>
        </mat-accordion>
      </div>
    </div>
  </ng-scrollbar>
</div>